/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useGetAutopayStatusQid = () => {
  const { get } = useAbortController();
  const { token } = useAuthContext();

  const [autopayStatusQidInfo, setAutopayStatusQidInfo] = useState([]);
  const [autopayStatusQidStatus, setAutopayStatusQidStatus] = useState('done');

  const getAutopayStatusQidInfo = useCallback(async () => {
    if (!token) return;
    const controller = get();
    const config = { signal: controller.signal };
    const headers = {
      'Session-Token': token,
    };
    try {
      setAutopayStatusQidStatus('loading');
      let response = await axiosCall({ url: 'live/master/qid/MASZ_CD.012/list', method: 'get' }, config, headers);
      setAutopayStatusQidInfo(response);
      setAutopayStatusQidStatus('done');
    } catch (e) {
      if (e.code !== 'ERR_CANCELED') {
        console.error('Unable to load autopay status options: ' + e);
        setAutopayStatusQidStatus('error');
      }
    }
  }, [get, token]);

  useEffect(() => {
    getAutopayStatusQidInfo();
  }, [getAutopayStatusQidInfo]);

  return {
    autopayStatusQidInfo,
    autopayStatusQidStatus,
  };
};

export default useGetAutopayStatusQid;
